import { JSX, memo, useState } from 'react'


// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Online from './online'
// eslint-disable-next-line @typescript-eslint/naming-convention
import Pigeonhole from './pigeonhole'




export enum TOptions {
	online = '在职员工',
	pigeonhole = '归档合同',

}


function main (props: { tab: TOptions }): JSX.Element
{
	if (props.tab === TOptions.online)
	{
		return <Online />

	}

	if (props.tab === TOptions.pigeonhole)
	{
		return <Pigeonhole />

	}

	return <></>

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export const Main = memo(main)


export default function (): JSX.Element
{
	let [tab, update_tab] = useState(TOptions.online)

	let on_change = (v: TOptions): void =>
	{
		update_tab(v)

	}

	return (
		<>
			<Layout.Header
				breadcrumb={['员工管理', tab]}
				options={[TOptions.online, TOptions.pigeonhole]}
				change={on_change}
			/>

			<Layout.Main>
				<Main tab={tab} />

			</Layout.Main>

		</>

	)

}

export { default as View } from './components/view.tsx'
